import { Controller } from "@hotwired/stimulus"

// The sheet tabs of a read-only spreadsheet (assistant_documents/_grid): one pane
// shows at a time, the tab row marks which, and the row count follows.
export default class extends Controller {
    static targets = ["pane", "tab", "count"]

    select(event) {
        const index = Number(event.currentTarget.dataset.index)
        this.paneTargets.forEach((pane, i) => { pane.hidden = i !== index })
        this.tabTargets.forEach((tab, i) => {
            tab.classList.toggle("is-active", i === index)
            tab.setAttribute("aria-selected", String(i === index))
        })
        if (this.hasCountTarget) {
            const rows = this.paneTargets[index].querySelectorAll("tbody tr").length
            this.countTarget.textContent = `${rows} ${rows === 1 ? "row" : "rows"}`
        }
    }
}
